module.exports = __webpack_public_path__ + "static/media/api-icon.5ee316ac.svg";